import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { createLoadingSelector } from '@hobs/utils/loading';
import { USER_ROLES } from '@hobs/utils/constants';
import WithEscNavigation from '@hobs/hocs/WithEscNavigation';
import WithRoles from '@hobs/hocs/WithRoles';
import { queryLocations } from '@hobs/actions/locations';
import { queryOData, resetOData } from '@hobs/actions/odata';
import {
  uploadAttachments,
  setAttachments,
  deleteAttachment,
  clearAttachments
} from '@hobs/actions/attachment';
import {
  getFooter,
  clearFooter,
  confirmServiceRequest
} from '@hobs/actions/serviceRequests';
import _ServiceRequestEdit from '@hobs/containers/ServiceRequestEdit';
import {
  createAcceptResponse,
  createRejectResponse,
  changeRequestAcceptResponse,
  changeRequestRejectResponse,
  createCancellationRequest
} from '@hobs/actions/tickets';
import {
  getServiceRequest,
  update,
  remove,
  forSubmit,
  calculateByDays,
  clearCalculateByDays
} from '../../actions/serviceRequests';

class ServiceRequestEdit extends _ServiceRequestEdit {
  async loadComponentData() {
    const {
      match,
      getServiceRequest,
      forSubmit,
      hasUserPermission,
      getFooter,
      setAttachments
    } = this.props;

    await forSubmit();
    await getServiceRequest(match.params.serviceRequestId).then(
      ({ payload }) => {
        setAttachments(payload.attachments);
        getFooter(match.params.serviceRequestId);
        this.setState({
          serviceRequest: {
            ...payload,
            originalIsTransportation: payload.isTransportation
          },
          disabled:
            !payload.canBeEdited ||
            hasUserPermission(USER_ROLES.READONLY) ||
            hasUserPermission(USER_ROLES.HOST_UNIT) ||
            payload.isAdditionalRequest
        });
      }
    );
    this.queryOdata();
  }

  getServiceRequestsGridUrl() {
    return '/requested-services';
  }

  getCatalogItemsQueryUrl() {
    return 'CatalogItemsQueryForServiceRequest';
  }

  getHistoryPath() {
    const { match } = this.props;
    return `/service-request-history/${match.params.serviceRequestId}`;
  }

  getEditPath() {
    const { match } = this.props;
    return `/service-request/${match.params.serviceRequestId}`;
  }

  getShowPath() {
    return null;
  }

  getTransportationPath() {
    const { match } = this.props;
    return `/service-request/${match.params.serviceRequestId}/transportation`;
  }

  getChangeHistoryPath() {
    const { match } = this.props;
    return `/service-request/${match.params.serviceRequestId}/change-history`;
  }

  getDiscussionInitials() {
    const { t } = this.props;
    return t('HN');
  }

  _remove() {
    const { match, remove } = this.props;

    return remove(match.params.serviceRequestId);
  }

  canUserAcceptResponse() {
    const { hasUserPermission } = this.props;

    return (
      !hasUserPermission(USER_ROLES.READONLY) &&
      !hasUserPermission(USER_ROLES.HOST_UNIT)
    );
  }

  getServiceRequestParent() {
    const { serviceRequest } = this.state;

    return serviceRequest.parentCategory
      ? {
          to: `/service-request/${serviceRequest.parentCategory.serviceRequestId}`,
          title: serviceRequest.parentCategory.name
        }
      : null;
  }

  getDiscussionPath() {
    const { match } = this.props;
    return `${match.url}/edit/discussion`
  }
}

const serviceRequestsLoading = createLoadingSelector([
  'ServiceRequests/Get',
  'ServiceRequests/ForSubmit'
]);

const mapStateToProps = state => ({
  isLoading: serviceRequestsLoading(state),
  query: state.locations.query,
  oData: state.odata,
  serviceRequest: state.serviceRequests.item,
  forSubmitData: state.serviceRequests.forSubmit,
  attachments: state.attachment.attachments,
  calculateByDaysData: state.serviceRequests.calculateByDays,
  footer: state.serviceRequests.footer
});

const mapDispatchToProps = {
  update,
  queryLocations,
  queryOData,
  resetOData,
  remove,
  getServiceRequest,
  confirmServiceRequest,
  forSubmit,
  uploadAttachments,
  setAttachments,
  deleteAttachment,
  clearAttachments,
  calculateByDays,
  clearCalculateByDays,
  getFooter,
  createAcceptResponse,
  createRejectResponse,
  changeRequestAcceptResponse,
  changeRequestRejectResponse,
  createCancellationRequest,
  clearFooter
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withTranslation()(
    withRouter(WithRoles(WithEscNavigation(ServiceRequestEdit)))
  )
);
